export default __webpack_public_path__ + "static/media/r.d4388d43.svg";